import { VertexElementFormat } from "../renders/VertexElementFormat";
export class VertexStateContext {
}
export class VertexDeclaration {
    get id() {
        return this._id;
    }
    get vertexStride() {
        return this._vertexStride;
    }
    get vertexElementCount() {
        return this._vertexElements.length;
    }
    constructor(vertexStride, vertexElements) {
        this._id = ++VertexDeclaration._uniqueIDCounter;
        this._vertexElementsDic = {};
        this._vertexStride = vertexStride;
        this._vertexElements = vertexElements;
        this._VAElements = [];
        var count = vertexElements.length;
        this._shaderValues = {};
        for (var j = 0; j < count; j++) {
            var vertexElement = vertexElements[j];
            var name = vertexElement._elementUsage;
            this._vertexElementsDic[name] = vertexElement;
            var value = new VertexStateContext();
            var elmentInfo = VertexElementFormat.getElementInfos(vertexElement._elementFormat);
            value.elementString = vertexElement._elementFormat;
            value.elementCount = elmentInfo[0];
            value.elementType = elmentInfo[1];
            value.normalized = elmentInfo[2];
            value.vertexStride = this._vertexStride;
            value.elementOffset = vertexElement._offset;
            this._shaderValues[name] = value;
            this._VAElements.push({ format: vertexElement._elementFormat, stride: vertexElement._offset, shaderLocation: name });
        }
    }
    getVertexElementByIndex(index) {
        return this._vertexElements[index];
    }
    getVertexElementByUsage(usage) {
        return this._vertexElementsDic[usage];
    }
}
VertexDeclaration._uniqueIDCounter = 1;
